import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1f706e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "砍价记录" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'goods_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.goods_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'price')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.goods_snap.price), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.getDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[3] || (_cache[3] = ($event: any) => ($setup.onSubmit('formRef')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: $setup.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "标签名称",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入标签名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标签描述",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.remark,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.remark) = $event)),
                  placeholder: "请输入标签描述"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible2) = $event)),
      title: _ctx.title,
      footer: null,
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, { bordered: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "砍价编号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.bargain_sn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品图片" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.detailData.goods_snap.goods_iamge,
                  style: {"width":"60px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods_snap.price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "砍价价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.bargain_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "当前价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.current_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "砍价状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "砍价人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.nickname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "砍价人头像" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.detailData.user.avatar,
                  style: {"width":"60px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "砍价人手机号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品最多优惠价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.bargain_snap.bargain_max_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品最少优惠价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.bargain_snap.bargain_min_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "第一刀价格" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.bargain_snap.first_knife_price), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}